if(typeof BSS_B2B !== undefined){
  setTimeout(()=>{
    const cartdrawer = document.querySelector('#CartDrawer');
    if(cartdrawer){
        const observer = new MutationObserver(()=>{
                        console.log(123);
          $('.product-single__price').removeAttr("bss-b2b-product-active");
            BSS_B2B.cp.changeProductPrice(JSON.parse($("#bss-b2b-store-data").html()), false, false)
        })
        observer.observe(cartdrawer, {attribute: true,childList: true, subtree:true})
    }
  },500)
}